var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTotalStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 19.5H6.75C5.51 19.5 4.5 18.49 4.5 17.25V3.75C4.5 3.34 4.16 3 3.75 3C3.34 3 3 3.34 3 3.75V17.25C3 19.32 4.68 21 6.75 21H20.25C20.66 21 21 20.66 21 20.25C21 19.84 20.66 19.5 20.25 19.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18C7.91 18 8.25 17.66 8.25 17.25V12C8.25 11.59 7.91 11.25 7.5 11.25C7.09 11.25 6.75 11.59 6.75 12V17.25C6.75 17.66 7.09 18 7.5 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5V17.25C10.5 17.66 10.84 18 11.25 18C11.66 18 12 17.66 12 17.25V10.5C12 10.09 11.66 9.75 11.25 9.75C10.84 9.75 10.5 10.09 10.5 10.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.75V17.25C14.25 17.66 14.59 18 15 18C15.41 18 15.75 17.66 15.75 17.25V12.75C15.75 12.34 15.41 12 15 12C14.59 12 14.25 12.34 14.25 12.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.75V17.25C18 17.66 18.34 18 18.75 18C19.16 18 19.5 17.66 19.5 17.25V9.75C19.5 9.34 19.16 9 18.75 9C18.34 9 18 9.34 18 9.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49994 9.75001C7.69994 9.75001 7.88994 9.67001 8.02994 9.53001L10.7199 6.84001C11.0199 6.56001 11.4799 6.56001 11.7799 6.84001L13.4099 8.47001C14.2899 9.35001 15.7099 9.35001 16.5899 8.47001L20.7799 4.28001C21.0699 3.98001 21.0599 3.51001 20.7599 3.22001C20.4699 2.94001 20.0099 2.94001 19.7199 3.22001L15.5299 7.41001C15.2399 7.70001 14.7599 7.70001 14.4699 7.41001L12.8399 5.78001C11.9599 4.90001 10.5399 4.90001 9.65994 5.78001L6.96994 8.47001C6.67994 8.76001 6.67994 9.24001 6.96994 9.53001C7.10994 9.67001 7.29994 9.75001 7.49994 9.75001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTotalStatistics);
export default __webpack_public_path__ + "static/media/ico-total-statistics.7795edad769116b6965b10c7bb35bc42.svg";
export { ForwardRef as ReactComponent };